import './custom_html.scss';

var THE_SCRIPT = function () {
	const $onReady = require('public/js/lib/on-ready');

	$onReady({
		rp$,
		window,
		label: 'custom_html',
		fn: function () {
			// We have already parsed and added lazysrc via the data.php.
			// Now we need to add the lazy-load class so it will get picked up by the lazy-load attach() below.
			rp$('.custom-html-module img[lazysrc]').each(function(){
				const img = rp$(this);
				if(!img.hasClass('lazy-load')) {
					img.addClass('lazy-load placeholder');
				}
			});
		},
	});
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
